import React, { useState } from 'react';
import {
  ChakraProvider, Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Checkbox,
  Box
} from '@chakra-ui/react';

export function ScentDial({ scent, onChange }) {
  const [checked, setChecked] = useState(false);
  const [value, setValue] = useState(0);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    if (!isChecked) {
      setValue(0);
    }
    onChange(scent, isChecked, value);
  };

  const handleSliderChange = (val) => {
    if (checked) {
      setValue(val);
      onChange(scent, checked, val);
    }
  };

  return (
    <Box display="flex" alignItems="left" justifyContent="flex-start" marginLeft="10px">
      <Checkbox
        isChecked={checked}
        onChange={handleCheckboxChange}
        marginRight="10px"
      >
        {scent}
      </Checkbox>
      <Slider
        aria-label='slider-ex-2'
        colorScheme='gray'
        value={value}
        onChange={handleSliderChange}
        isDisabled={!checked}
        max={100}
        width={window.innerWidth < 768 ? '30vw' : '10vw'}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </Slider>
    </Box>
  );
}